import { ReplaceProducts, Management } from './pages';

export { ReplaceProducts, Management };
